const TabTitle: React.FC<{
  title: string;
  subTitle?: string;
  isActive: boolean;
}> = ({ title, subTitle, isActive }) => {
  return (
    <div
      className={`pt-3 pb-8 group flex flex-col justify-center cursor-pointer text-[#121C59]/80 font-300 transition-all duration-300 ease-in-out text-left ${
        isActive ? '!text-[#121C59] font-400' : ''
      } hover:!text-[#121C59] hover:font-400 mobile:pt-2 mobile:pb-2`}
    >
      <h3 className="text-[32px] leading-[1.5] mobile:text-[16px] break-words hyphens-auto">
        {title}
      </h3>
      <span
        className={`break-words hyphens-auto text-[24px] leading-[1.5] mobile:text-[12px] font-300 mobile:mt-[2px]`}
      >
        {subTitle}
      </span>
      {/* <span
        className={`break-words hyphens-auto text-[20px] leading-[1.5] transition-all duration-300 ease-in-out ${
          isActive ? 'visible opacity-100 -mt-0' : 'invisible opacity-0 -mt-7'
        } group-hover:opacity-100 group-hover:visible group-hover:-mt-0 mobile:text-[12px] mobile:hidden`}
      >
        {subTitle}
      </span> */}
    </div>
  );
};

export default TabTitle;
